// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2j3f4","title":"Header_title__3Q9Jl","left":"Header_left__1xgJM","clinicName":"Header_clinicName__2_02N"};